module.exports = __webpack_public_path__ + "static/media/about-2.ec1561c4.jpg";